"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.login2FASelector = void 0;
const login2FASelector = (state) => state.login2FA;
exports.login2FASelector = login2FASelector;
